



























import { Employe } from "../../models/Employe";
import NumeralInput from "../../core/Forms/NumeraInput.vue";
import DateInput from "../../core/Forms/DateInput.vue";
import Avenant = Employe.Avenant;

export default {
    name: "AvenantModalEdit",
    components: { DateInput, NumeralInput },
    props: {
        avenant: Avenant,
    },
    data() {
        return {};
    },
};
